import { Designation, Total } from "../types"

export function designationTotalCents(designations: Designation[]): Total {
  const totalCents = designations.reduce((totalCents, designation) => {
    const amountInCents = Math.round(parseFloat(designation.amount) * 100) || 0
    return totalCents + amountInCents
  }, 0)

  return totalCents
}

export function designationTotal(designations: Designation[]): Total {
  return designationTotalCents(designations) / 100
}

export function formattedCents(cents: number): string {
  const dollars = cents / 100
  const isWholeDollar = cents % 100 === 0
  if (isWholeDollar) {
    return `$${dollars.toLocaleString("en-US")}`
  } else {
    return `$${dollars.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  }
}
